module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAAAXNSR0IArs4c6QAAANdJREFUGNNjYICCdWpb52x5sfXllsUbtBhQwVaDrXe2/tv6Hwj/bXm4zRpJahXblh1gCRg8uIoTLrlTdstdFMmHW5TgkpsUtz5AltzydKsaXHIj79YTKJLntwgi2bolYttnqIP+b/m2ORXFtf8ZN4dsuQ6U/rfl9uboVcxIUhultiRvlZ/JtU1ri85mrp2yG2O2SkClNuhuvbj1D9BJKzc3bK3fsnzrva1/tpwFO2m9wBYUx8AddWgjL8O2gK0/sElu/b7Fm2HbOqxSILiCYcvDLZ+xw613ADgv2DG3EGRWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/indexStyle3/user.png
// module id = J0F0
// module chunks = 1